import { EventPageState } from 'src/domains/sportsbook/trading/state/EventPageState';
import { LocalStorageState } from 'src/AppState/LocalStorageState/LocalStorageState';

export class SportsbookState {
    public readonly eventPageState: EventPageState;

    public constructor(readonly localStorage: LocalStorageState) {
        this.eventPageState = new EventPageState(localStorage);

    }


}
